import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useAuth } from '../context/AuthContext';

const fmt=v=>v?new Intl.DateTimeFormat('en-US',{month:'short',day:'numeric',year:'numeric'}).format(new Date(v)):'—';

export default function NotALeadPage(){
  const {workspace}=useAuth();
  const [rows,setRows]=useState([]),[loading,setLoading]=useState(true),[error,setError]=useState(''),[busy,setBusy]=useState('');
  const load=useCallback(async()=>{
    setLoading(true);setError('');
    const {data,error:e}=await supabase.from('leads')
      .select('id,name,instagram_handle,motion,lead_entered_at,not_a_lead_reason,not_a_lead_note,not_a_lead_at')
      .eq('workspace_id',workspace.id).eq('validity','not_a_lead').is('deleted_at',null)
      .order('not_a_lead_at',{ascending:false});
    if(e)setError(e.message);else setRows(data||[]);
    setLoading(false);
  },[workspace.id]);
  useEffect(()=>{load()},[load]);

  async function restore(id){
    if(!confirm('Restore this person as an active Lead?'))return;
    setBusy(id);setError('');
    const {error:e}=await supabase.rpc('restore_not_a_lead',{p_lead_id:id});
    setBusy('');if(e)setError(e.message);else load();
  }

  return <section className="page-stack">
    <div className="page-head-row"><div><Link className="back-link" to="/leads?view=archived">← Archived</Link><h1 className="page-title">Not a Lead</h1><p className="page-description">People initially entered as Leads who were later determined not to be valid Leads.</p></div></div>
    {error&&<div className="error-message">{error}</div>}
    <div className="panel">{loading?<div className="empty-state">Loading…</div>:rows.length===0?<div className="empty-state"><strong>No Not-a-Lead records.</strong></div>:rows.map(row=><div className="not-lead-row" key={row.id}>
      <div><Link to={`/leads/${row.id}`}><strong>{row.name}</strong></Link><span>{row.instagram_handle||'—'} · {row.motion}</span><small>Marked {fmt(row.not_a_lead_at)} · {row.not_a_lead_reason}</small>{row.not_a_lead_note&&<p>{row.not_a_lead_note}</p>}</div>
      <button className="secondary-button" disabled={busy===row.id} onClick={()=>restore(row.id)}>{busy===row.id?'Restoring…':'Restore as Lead'}</button>
    </div>)}</div>
  </section>;
}
